module.exports = require("node:crypto");